import React, {useState} from "react";
import "./LoginPage.css";

interface LoginPageProps {
    onLogin: () => void;
}

const LoginPage: React.FC<LoginPageProps> = ({onLogin}) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showError, setShowError] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (username === "Andreas" && password === "ETHZurich") {
            setShowError(false);
            onLogin();
        } else {
            setShowError(true);
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleSubmit} className="login-form">
                <h2>Artwork Similarity <br/> Dashboard</h2>
                <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />
                <button type="submit">Login</button>
                <div
                    className="login-error"
                    style={{visibility: showError ? "visible" : "hidden"}}
                >
                    Try Again.
                </div>
            </form>
        </div>
    );
};

export default LoginPage;